
import Key from "../../../assets/outline/Key.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function KeyIcon({ className, dataTestid = "KeyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Key data-testid={dataTestid} className={classes} {...rest} />
  );
}
